import { mockSourceDomains } from './domains';
import { mockDomainTypeShares } from './common';
import { mockRecentChats } from './chat';

export const mockOverviewData = {
  workspace_name: 'tradingbase',
  total_domains: 289,
  total_urls: 1243,
  total_prompts: 50,
  active_campaigns: 5,
  last_updated: '2026-05-27T10:30:00Z',
  metrics: {
    crawled_pages: 3000,
    errors: 0,
    success_rate: 100
  },
  top_brands: [
    { rank: 1, domain: 'robinhood.co.th', name: 'Robinhood', visibility: 63, sov: 59, sentiment: 62, position: 2.4, delta: { value: '-', tone: 'flat' as const } },
    { rank: 2, domain: 'thinkorswim.com', name: 'thinkorswim', visibility: 26, sov: 17, sentiment: 63, position: 4.8, delta: { value: '-', tone: 'flat' as const } },
    { rank: 3, domain: 'etoro.com', name: 'eToro', visibility: 15, sov: 10, sentiment: 61, position: 4.5, delta: { value: '-', tone: 'flat' as const } },
    { rank: 4, domain: 'tradingview.com', name: 'TradingView', visibility: 15, sov: 13, sentiment: 63, position: 2.4, delta: { value: '-', tone: 'flat' as const } },
    { rank: 5, domain: 'prorealtime.com', name: 'ProRealTime', visibility: 0, sov: 0, sentiment: 85, position: 2.0, delta: { value: '-', tone: 'flat' as const } },
    { rank: 6, domain: 'kite.trade', name: 'Kite', visibility: 0, sov: 0, sentiment: null, position: null, delta: { value: '-', tone: 'flat' as const } },
    { rank: 7, domain: 'tradingbase.ai', name: 'tradingbase', visibility: 0, sov: 0, sentiment: null, position: null, delta: { value: '-', tone: 'flat' as const } },
  ],
  top_domains: mockSourceDomains,
  domain_types: mockDomainTypeShares,
  recent_chats: mockRecentChats,
  account_quick_overview: {
    brand_name: 'TradingBase',
    brand_icon_url: 'https://www.google.com/s2/favicons?domain=tradingbase.ai&sz=64',
    period_label: '过去一周',
    visibility_delta: {
      value: '+15.2%',
      direction: 'up' as const,
    },
    topic: {
      name: '资产管理平台',
      average_rank: 2.4,
    },
    platform: {
      name: 'ChatGPT',
      highlight: '占据首位推荐',
    },
  },
};
